import React from "react";
import { BarChart3, BookOpen, BriefcaseBusiness, Building2, ClipboardCheck, FileText, Gavel, LayoutDashboard, Landmark, Map, Settings, ShieldCheck, Users, Warehouse } from "lucide-react";
import { AdminTopbar, BrandMark, Screen } from "./GovShell";
const nav: Array<{
  label: string;
  icon: React.ElementType;
  screen?: Screen;
}> = [{
  label: "ড্যাশবোর্ড",
  icon: LayoutDashboard,
  screen: "adminDistrict"
}, {
  label: "আগত আবেদন",
  icon: BriefcaseBusiness,
  screen: "adminQueue"
}, {
  label: "আমার কার্যতালিকা",
  icon: ClipboardCheck,
  screen: "adminQueue"
}, {
  label: "সকল আবেদন",
  icon: FileText,
  screen: "adminQueue"
}, {
  label: "সংশোধনাধীন আবেদন",
  icon: FileText,
  screen: "adminQueue"
}, {
  label: "মাঠ তদন্ত",
  icon: Map,
  screen: "adminDetail"
}, {
  label: "অনুমোদনের অপেক্ষায়",
  icon: ShieldCheck,
  screen: "adminQueue"
}, {
  label: "ওয়াক্‌ফ এস্টেট",
  icon: Landmark,
  screen: "registry"
}, {
  label: "জমি ও সম্পত্তি",
  icon: Warehouse,
  screen: "registry"
}, {
  label: "অন্যান্য সম্পদ",
  icon: BriefcaseBusiness,
  screen: "registry"
}, {
  label: "মামলা-মোকদ্দমা",
  icon: Gavel,
  screen: "registry"
}, {
  label: "দলিল ভান্ডার",
  icon: BookOpen,
  screen: "registry"
}, {
  label: "প্রতিবেদন",
  icon: BarChart3,
  screen: "reports"
}, {
  label: "অফিস ব্যবস্থাপনা",
  icon: Building2
}, {
  label: "ব্যবহারকারী ও ভূমিকা",
  icon: Users
}, {
  label: "অডিট লগ",
  icon: ShieldCheck
}, {
  label: "সিস্টেম সেটিংস",
  icon: Settings
}];
export function AdminShell({
  screen,
  setScreen,
  role,
  office,
  children
}: {
  screen: Screen;
  setScreen: (screen: Screen) => void;
  role: string;
  office: string;
  children: React.ReactNode;
}) {
  const isActive = (item: typeof nav[number]) => item.screen === screen || item.label === "ড্যাশবোর্ড" && ["adminDistrict", "adminDivision", "adminHead"].includes(screen);
  return <div className="min-h-screen bg-[#f4f7f6] text-slate-900" data-id="element-19" data-mp="3kozgxblqioqz"><aside className="fixed inset-y-0 left-0 z-30 hidden w-[268px] flex-col bg-[#073b30] lg:flex" data-id="element-20" data-mp="3fqxvik0u6dcc"><div className="border-b border-white/15 p-5" data-id="element-21" data-mp="3brgovn9oba5l"><BrandMark inverse data-id="element-22" data-mp="3bsiaums89h23" /><p className="mt-3 text-xs text-white/60" data-id="element-23" data-mp="315acj26ddev2">অভ্যন্তরীণ প্রশাসনিক পোর্টাল</p></div><nav className="flex-1 overflow-y-auto p-3" aria-label="প্রশাসনিক নেভিগেশন" data-id="element-24" data-mp="317ekbv7e2y0m">{nav.map(item => {
          const Icon = item.icon;
          return <button key={item.label} onClick={() => item.screen && setScreen(item.screen)} className={`mb-0.5 flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm transition ${isActive(item) ? "bg-white/15 font-bold text-white" : "text-white/75 hover:bg-white/10 hover:text-white"}`} data-id="element-25" data-mp="2s4vmxqmdhdlr"><Icon className="h-4 w-4" data-id="element-26" data-mp="3ouv3a78rlgew" />{item.label}</button>;
        })}</nav><div className="border-t border-white/15 p-4 text-xs text-white/60" data-id="element-27" data-mp="3oud2qyf2kg16">ভূমিকা-ভিত্তিক প্রবেশাধিকার সক্রিয়<br data-id="element-28" data-mp="3b2yeod6b1on9" />ডেমো সংস্করণ · v0.9</div></aside><main className="lg:ml-[268px]" data-id="element-29" data-mp="3g2krili812vj"><AdminTopbar role={role} office={office} setScreen={setScreen} data-id="element-30" data-mp="3g1j6bo7hr003" />{children}</main></div>;
}